import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import * as Component from './ResultsFooter.styles'

import { Link, Button, PrintButton } from 'components/atoms'
import { entryPointId } from 'settings/app/constants'
import { TextContext } from 'hocs'
import { useSelector } from 'react-redux'

const ResultsFooter = React.memo(
  ({
    showLoadMoreButton,
    onLoadMoreClicked,
    onPrintOpenAll,
    onPrintBtnClicked,
  }) => {
    const entryPoint = useSelector((state) => state.application.entryPoint)
    const healthNavigatorCrossUrl = React.useRef(
      localStorage.getItem('crossSearchURL') || 'Querschnittsuche'
    )
    const careNavigatorCrossUrl = React.useRef(
      localStorage.getItem('careSearchSearchURL') || 'Pflegenavigator'
    )

    const healthEntryPoints = [
      entryPointId.HOSPITALS,
      entryPointId.DOCTORS,
      entryPointId.MIDWIVES,
      entryPointId.AMBULANCES,
      entryPointId.ONCALLSERVICES,
      entryPointId.CROSS,
    ]
    const careEntryPoints = [
      entryPointId.CARESERVICES,
      entryPointId.CAREHOMES,
      entryPointId.DAYANDNIGHTCARE,
      entryPointId.CARESUPPORT,
      entryPointId.CARESEARCH,
    ]

    const textContext = useContext(TextContext)

    const getCrossSearchUrl = () => {
      if (healthEntryPoints.includes(entryPoint)) {
        return healthNavigatorCrossUrl.current
      }
      if (careEntryPoints.includes(entryPoint)) {
        return careNavigatorCrossUrl.current
      }
    }

    return (
      <Component.Root>
        <Link
          id='search-something-else-link'
          isNativeLink
          href={ getCrossSearchUrl() }
          className='more-link'>
          {textContext['link.searchFor.SomeThingElse']}
        </Link>
        <PrintButton
          className={ 'bookmark-print' }
          data-cy='bookmark-print-btn'
          onPrintBtnClicked={ onPrintBtnClicked }
          onPrintOpenAll={ onPrintOpenAll }
        />
        {showLoadMoreButton && (
          <Button
            id='load-more-results'
            data-cy='load-more-results'
            text='10 weitere Ergebnisse'
            onClick={ onLoadMoreClicked }
            className='btn-alternative btn-all'
          />
        )}
      </Component.Root>
    )
  }
)

ResultsFooter.defaultProps = {
  showLoadMoreButton: false,
}

ResultsFooter.propTypes = {
  onLoadMoreClicked: PropTypes.func.isRequired,
  onPrintBtnClicked: PropTypes.func.isRequired,
  showLoadMoreButton: PropTypes.bool,
}

export default ResultsFooter
